import { render, staticRenderFns } from "./work-order-export.vue?vue&type=template&id=052bc58f"
import script from "./work-order-export.vue?vue&type=script&lang=ts"
export * from "./work-order-export.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports